import type { Extension } from "@tiptap/react";
import { StarterKit } from "@tiptap/starter-kit";

export const CustomStarterKitExtension = (): Extension => {
  return StarterKit.configure({
    paragraph: {
      HTMLAttributes: {
        class: "editor-paragraph-block"
      }
    },
    heading: {
      HTMLAttributes: {
        class: "editor-heading-block"
      }
    }
  });
};
